import axios from '@/api/axios';
import type {
  AdminPinResetDecisionPayload,
  AdminPinResetRequest,
  AdminPinResetRequestListResponse,
  BusinessPinResetRequestStatus,
} from '@/types';

const BASE_URL = '/v2/admin/business/pin-reset-requests';

/**
 * Business transaction-PIN reset requests. Approving one clears the account's
 * PIN, which is why the route itself is finance-only even though reading the
 * queue is open to every admin role.
 */
export const pinResetRequestService = {
  getList: async (
    filters: {
      status?: BusinessPinResetRequestStatus;
      businessId?: string;
      page?: number;
      limit?: number;
    } = {},
  ): Promise<AdminPinResetRequestListResponse> => {
    const query: Record<string, string> = {
      page: String(filters.page ?? 0),
      limit: String(filters.limit ?? 10),
    };
    if (filters.status) {
      query.status = filters.status;
    }
    if (filters.businessId) {
      query.businessId = filters.businessId;
    }
    const response = await axios.get<AdminPinResetRequestListResponse>(
      `${BASE_URL}?${new URLSearchParams(query).toString()}`,
    );
    return response?.data;
  },

  decide: async (
    requestId: string,
    payload: AdminPinResetDecisionPayload,
  ): Promise<AdminPinResetRequest> => {
    const response = await axios.patch<AdminPinResetRequest>(
      `${BASE_URL}/${requestId}`,
      payload,
    );
    return response?.data;
  },
};
